// this is just a constant mapping for now, until we can figure out a better way.
// this is needed for the condition humanizer to show the state name instead of id.
// one possible solution to this is to actually support network requests coming from this package,
// which may enable other powerful features in the future, but we aren't ready to open that can of worms yet.
export const STATES_MAPPING = {
    1: 'California',
    2: 'Texas',
    3: 'Florida',
    4: 'Arizona',
    5: 'Georgia',
    6: 'Alabama',
    7: 'Alaska',
    8: 'Arkansas',
    9: 'Colorado',
    10: 'Connecticut',
    11: 'Delaware',
    12: 'District of Columbia',
    13: 'Hawaii',
    14: 'Idaho',
    15: 'Illinois',
    16: 'Indiana',
    17: 'Iowa',
    18: 'Kansas',
    19: 'Kentucky',
    20: 'Louisiana',
    21: 'Maine',
    22: 'Maryland',
    23: 'Massachusetts',
    24: 'Michigan',
    25: 'Minnesota',
    26: 'Mississippi',
    27: 'Missouri',
    28: 'Montana',
    29: 'Nebraska',
    30: 'Nevada',
    31: 'New Hampshire',
    32: 'New Jersey',
    33: 'New Mexico',
    34: 'New York',
    35: 'North Carolina',
    36: 'North Dakota',
    37: 'Ohio',
    38: 'Oklahoma',
    39: 'Oregon',
    40: 'Pennsylvania',
    41: 'Puerto Rico',
    42: 'Rhode Island',
    43: 'South Carolina',
    44: 'South Dakota',
    45: 'Tennessee',
    46: 'Utah',
    47: 'Vermont',
    48: 'Virginia',
    49: 'Washington',
    50: 'Wisconsin',
    52: 'Wyoming',
};
